export default "__VITE_ASSET__CruTtc2E__"